export default class CPFUtils {
	static isValidCPF(cpf) {
		if (typeof cpf !== 'string') return false

		cpf = cpf.replace(/\D/g, '')

		if (cpf.length !== 11 || /^(\d)\1*$/.test(cpf)) return false

		try {
			const digits = cpf.split('').map(Number)
			const sum1 = digits.slice(0, 9).reduce((sum, digit, index) => sum + digit * (10 - index), 0)
			const check1 = sum1 % 11 < 2 ? 0 : 11 - (sum1 % 11)

			const sum2 = digits.slice(0, 10).reduce((sum, digit, index) => sum + digit * (11 - index), 0)
			const check2 = sum2 % 11 < 2 ? 0 : 11 - (sum2 % 11)

			return check1 === digits[9] && check2 === digits[10]
		} catch (e) {
			return false
		}
	}
}
